import * as actionTypes from "./actionTypes";

export const getTotalNotificationAction = () => ({
	type: actionTypes.GET_TOTAL_NOTIFICATION_ACTION
});

export const setTotalNotificationAction = params => ({
	type: actionTypes.SET_TOTAL_NOTIFICATION_ACTION,
	params
});

export const getListNotificationAction = params => ({
	type: actionTypes.GET_LIST_NOTIFICATION_ACTION,
	params
});

export const setListNotificationAction = params => ({
	type: actionTypes.SET_LIST_NOTIFICATION_ACTION,
	params
});

export const getNotificationDetailAction = params => ({
	type: actionTypes.GET_NOTIFICATION_DETAIL_ACTION,
	params
});

export const setNotificationDetailAction = params => ({
	type: actionTypes.SET_NOTIFICATION_DETAIL_ACTION,
	params
});

export const postWatchedNotificationAction = params => ({
	type: actionTypes.POST_WATCHED_NOTIFICATION_ACTION,
	params
});

export const menuNotificationAction = params => ({
	type: actionTypes.MENU_NOTIFICATION_ACTION,
	params
});
